import { useState } from 'react';
import { BiSearch } from 'react-icons/bi';

const Search = ({ onChangeAction, value }) => {
  const [inputValue, setInputValue] = useState(value);

  const handleSearchChange = (event) => {
    if (event.target.value.includes('\\')) {
      event.preventDefault();
    } else {
      setInputValue(event.target.value);
      onChangeAction(event.target.value);
    }
  };

  return (
    <div className="w-full relative">
      <div className="absolute flex inset-y-0 left-0 items-center pl-4 pointer-events-none">
        <BiSearch className="text-icons" size={20} />
      </div>
      <input
        autoFocus={true}
        type="input"
        value={inputValue}
        id="part-search"
        onChange={handleSearchChange}
        className="block w-full py-1.5 text-sm md:text-base md:py-3 pl-12 border border-gray-300 focus:outline-none"
        placeholder="Пошук..."
      />
    </div>
  );
};

export default Search;
